import React from 'react'
import './BlueLine.scss'

const BlueLine = (props) => <div className='blueLine'>{props.children}</div>

export default BlueLine
